var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentApplePay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Logo-Payment-Apple-Pay",
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_29",
    d: "M2-23h31a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-19a2 2 0 0 1 2-2z",
    className: "prefix__cls-1",
    "data-name": "Path 29",
    transform: "translate(0 23)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_32",
    d: "M12.02-12.444a1.906 1.906 0 0 0 1.188 1.735A4.62 4.62 0 0 1 12.6-9.49c-.369.522-.752 1.043-1.355 1.054s-.783-.34-1.461-.34-.889.329-1.45.351C7.747-8.4 7.3-8.99 6.931-9.511c-.76-1.065-1.341-3.008-.561-4.32a2.177 2.177 0 0 1 1.83-1.075c.572-.011 1.111.372 1.461.372s1.005-.461 1.695-.393a2.091 2.091 0 0 1 1.619.851 1.936 1.936 0 0 0-.957 1.632M25.245-14.1l1.445 3.61q.119.3.225.619t.189.584h.024l.189-.573q.106-.319.237-.654l1.351-3.586h.595l-1.646 4.073q-.249.648-.468 1.174t-.444.949a6.743 6.743 0 0 1-.456.747 3.146 3.146 0 0 1-.515.567 2.8 2.8 0 0 1-.61.422q-.278.133-.373.168l-.19-.451a4.789 4.789 0 0 0 .474-.243 2.579 2.579 0 0 0 .509-.393 4.68 4.68 0 0 0 .468-.55 3.837 3.837 0 0 0 .456-.827.921.921 0 0 0 .071-.243.685.685 0 0 0-.071-.243l-2.053-5.15zm-3.008-.127a2.066 2.066 0 0 1 .966.2 1.593 1.593 0 0 1 .586.509 1.876 1.876 0 0 1 .29.7 3.949 3.949 0 0 1 .077.769v2.187q0 .335.011.671a4.238 4.238 0 0 0 .071.648h-.521l-.083-.787h-.024a1.968 1.968 0 0 1-.272.324 2.138 2.138 0 0 1-.385.3 2.057 2.057 0 0 1-.5.214 2.189 2.189 0 0 1-.61.081 1.865 1.865 0 0 1-.729-.133A1.5 1.5 0 0 1 20.6-8.9a1.416 1.416 0 0 1-.3-.492 1.621 1.621 0 0 1-.1-.555 1.692 1.692 0 0 1 .847-1.516 4.751 4.751 0 0 1 2.553-.507v-.15a3.545 3.545 0 0 0-.041-.5 1.557 1.557 0 0 0-.184-.538 1.172 1.172 0 0 0-.426-.428 1.47 1.47 0 0 0-.77-.174 2.49 2.49 0 0 0-.728.11 2.488 2.488 0 0 0-.657.307l-.178-.405a2.654 2.654 0 0 1 .782-.364 3.184 3.184 0 0 1 .839-.115zM17.051-16.4a3.977 3.977 0 0 1 1.226.168 2.21 2.21 0 0 1 .847.48 1.973 1.973 0 0 1 .444.659 2.263 2.263 0 0 1 .159.879 2.383 2.383 0 0 1-.219 1.053 2.193 2.193 0 0 1-.6.758 2.533 2.533 0 0 1-.9.457 4.09 4.09 0 0 1-1.137.15 4.572 4.572 0 0 1-.935-.081v3.332h-.557v-7.706q.344-.058.758-.1a8.2 8.2 0 0 1 .914-.049zm5.606 4.918a3.479 3.479 0 0 0-.906.2 1.727 1.727 0 0 0-.687.457 1.143 1.143 0 0 0-.273.8 1.05 1.05 0 0 0 .344.868 1.193 1.193 0 0 0 .77.278 1.9 1.9 0 0 0 .616-.093 1.613 1.613 0 0 0 .474-.249 1.59 1.59 0 0 0 .338-.353 1.642 1.642 0 0 0 .208-.405 1.55 1.55 0 0 0 .059-.336v-1.2a7.8 7.8 0 0 0-.943.031zm-5.63-4.455a6.288 6.288 0 0 0-.652.029q-.272.029-.438.064v3.483a2.468 2.468 0 0 0 .45.081q.249.023.533.023a2.521 2.521 0 0 0 1.652-.486 1.743 1.743 0 0 0 .586-1.423 1.871 1.871 0 0 0-.154-.787 1.415 1.415 0 0 0-.438-.55 2.018 2.018 0 0 0-.675-.324 3.2 3.2 0 0 0-.864-.112zM11.367-17a1.851 1.851 0 0 1-.461 1.369 1.662 1.662 0 0 1-1.313.607 1.76 1.76 0 0 1 .47-1.326 2.006 2.006 0 0 1 1.304-.65z",
    className: "prefix__cls-1",
    "data-name": "Path 32",
    transform: "translate(-6 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_3",
    d: "M0 0H34V23H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle 3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_31",
    d: "M5-5h25v-13H5z",
    className: "prefix__cls-1",
    "data-name": "Path 31",
    transform: "translate(-5 18)"
  })), /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_22",
    clipPath: "url(#prefix__clip-path)",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_28",
    d: "M-5-28h45V5H-5z",
    "data-name": "Path 28",
    transform: "translate(0 23)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_26",
    clipPath: "url(#prefix__clip-path-2)",
    "data-name": "Group 26",
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_25",
    "data-name": "Group 25",
    transform: "translate(-5 -6)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_24",
    clipPath: "url(#prefix__clip-path-3)",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_23",
    clipPath: "url(#prefix__clip-path-4)",
    "data-name": "Group 23",
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_30",
    fill: "#fff",
    d: "M1-22h33.5v21H1z",
    "data-name": "Path 30",
    transform: "translate(-5 18)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentApplePay);
export default __webpack_public_path__ + "static/media/logo-payment-apple-pay.81c0cf23.svg";
export { ForwardRef as ReactComponent };